import * as React from 'react';

interface Props extends React.PropsWithChildren {
	title?: string;
	bodyClassName?: string;
	collapsable?: boolean;
	startCollapsed?: boolean;
	headerChildren?: React.ReactNode;
	maximizable?: boolean;
	className?: string;

	onMaximizedChanged?: (maximized: boolean) => void;
}

class _Panel extends React.Component<Props, { collapsed: boolean, fullscreen: boolean }> {

	public ref = React.createRef<HTMLDivElement>();

	constructor(props: Props) {
		super(props);
		this.state = {
			collapsed: this.props.startCollapsed || false,
			fullscreen: false
		};

		this.onToggleCollapsed = this.onToggleCollapsed.bind(this);
		this.onToggleMaximized = this.onToggleMaximized.bind(this);
	}

	componentDidMount() {
		if (this.props.startCollapsed) {
			$('.panel-body', this.ref.current!).slideToggle(0);
			$('.panel-footer', this.ref.current!).slideToggle(0);
		}
	}

	private onToggleCollapsed(e: React.MouseEvent<any>) {

		if (!this.props.collapsable)
			return;

		e.stopPropagation();

		this.setState({ collapsed: !this.state.collapsed });

		$('.panel-body', this.ref.current!).slideToggle(300);
		$('.panel-footer', this.ref.current!).slideToggle(200);
	}

	private onToggleMaximized() {
		this.setState({ fullscreen: !this.state.fullscreen }, () => {
			this.props.onMaximizedChanged?.(this.state.fullscreen);
		});
	}

	buildTools() {
		return <div className='panel-tools'>
			{this.props.collapsable ? <a className='showhide' onClick={this.onToggleCollapsed}><i className={`fa fa-chevron-${this.state.collapsed ? 'left' : 'down'}`}></i></a> : null}
			{this.props.maximizable ? <a onClick={this.onToggleMaximized}><i className={this.state.fullscreen ? 'fa fa-window-restore' : 'fa fa-window-maximize'}></i></a> : null}
		</div>;
	}

	render() {

		const tools = this.buildTools();
		const headerChildren = this.props.headerChildren
			? <div className='pull-right'>{this.props.headerChildren}</div>
			: null;
		const headerStyle = { cursor: this.props.collapsable ? 'pointer' : 'default' };
		const header = this.props.title && <div className='panel-heading' onClick={this.onToggleCollapsed} style={headerStyle}>{tools}{headerChildren}{this.props.title}</div>;
		const className = this.props.className || (this.props.title ? 'hblue' : '');

		return <div ref={this.ref} className={`hpanel ${className} ${this.state.collapsed ? 'panel-collapse' : ''} ${this.state.fullscreen ? 'fullscreen' : ''}`}>
			{header}
			<div className={`panel-body ${this.props.bodyClassName || ''} `}>
				{this.props.children}
			</div>
		</div>;
	}
}


const Panel = React.forwardRef<HTMLDivElement, Props>((props, ref) => {

	const panel = React.useRef<_Panel>(null);

	React.useImperativeHandle(ref, () => panel.current?.ref.current!);

	return <_Panel {...props} ref={panel} />;
});


export default Panel;

